import { createSelector } from 'reselect'

const getOnboardingData = state => state.onboarding

const onboardingStepSelector = createSelector(
	[getOnboardingData],
	onboarding => ({
		fromStore: onboarding.fromStore,
		step: onboarding.step,
	})
)

export default onboardingStepSelector
